module.exports = __webpack_public_path__ + "static/media/activity.6f0a17c5.svg";